/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-08 17:51:33
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:21:06
 */
export default [
  {
    path: '/marketing-analysis',
    name: 'marketing-analysis',
    meta: {
      name: '营销分析',
      keepAlive: true
    },
    redirect: { name: 'board' }
  },
  {
    path: '/board',
    name: 'board',
    meta: {
      name: '销售概览',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "analysis" */'../views/marketing-analysis/board/index.vue')
  },
  {
    path: '/ad-analysis',
    name: 'ad-analysis',
    meta: {
      name: '广告分析',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */ '../views/marketing-analysis/ad-analysis/index.vue')
  },
]
